module.exports = __webpack_public_path__ + "img/vip-crowd_cclub_600.c438e8e3.webp";